module.exports = __webpack_public_path__ + "static/media/fondo_karaoke.717c2f49.jpg";